import React from "react";
import { Box, Grid2, List, ListItem, ListItemIcon, ListItemText, Typography } from "@mui/material";

import dashboard from "../../../../Images/safetyWalk/dashboard.png";
import formList from "../../../../Images/safetyWalk/formlist.png";
import formPage from "../../../../Images/safetyWalk/formpage.png";
import wave from "../../../../Images/aboutUsBg.jpg";
// import wave from "../../../../Images/aboutUsBg.jpg";
import { commonCss } from "../../../../CssStyle/commonCss";
import WaveBackground from "../../../../Component/WaveBackground";
import { ArrowForward } from "@mui/icons-material";

const SafetyWalk = () => {
  return (
    <Grid2 container spacing={"2rem"} >
     <WaveBackground menu={"Our Products"} title={"Safety Walk"} description={"Enhancing Workplace Safety Through Digital Inspections"}/>
    

     <Grid2 container justifyContent={"center"}>
           <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"0 3rem 3rem 3rem"},maxWidth:{xs:"auto",xl:"2000px"}}} alignItems={"center"} mt="-10%" >
             <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-start"}}>
            <img src={dashboard} style={{width:'85%',height:"100%"}}/>
        </Grid2>
        <Grid2 size={{xs:12,md:6}} sx={{pr:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},textAlign:{xs:"center",md:"left"},fontWeight:700,fontFamily:"inherit"}}>Industrial Safety Walk Web App & Mobile App</Typography>
            <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography>
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1rem",
              fontWeight:600
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:1,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Inspection & Audits</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Incident Reporting</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Checklists & Guidelines</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Data Tracking & Analytics</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Corrective Actions</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Compliance Management</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%",md:"40%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Employee Engagement</ListItemText>
                </ListItem>
            </List>
        </Grid2>
     </Grid2>
     </Grid2>
<Grid2 container justifyContent={"center"} sx={{background:commonCss.backgroundGray}} >
     <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"3rem"},maxWidth:{xs:"auto",md:"2000px"}}} alignItems={"center"}>
     <Grid2 size={{xs:12,md:6}} sx={{pl:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},fontWeight:700,fontFamily:"inherit"}}>Are you struggling with registering your
safety findings and resolving the issue
efficiently?
</Typography>
            <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>Look no further than our Safety Walk
solution.
</Typography>
            
            {/* <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Key Features</Typography> */}
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1rem",
              fontWeight:600
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:4,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Ability to report safety findings digitally</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Digitally route for multiple approvals
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Ability to attach images of the findings
                  </ListItemText>
                </ListItem>
              
            </List>
        </Grid2>
        <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-end"}}>
            <img src={formList} style={{width:'85%',height:"100%"}}/>
        </Grid2>
      
     </Grid2>
     </Grid2>
      <Grid2 container justifyContent={"center"}>
         <Grid2 container size={12} spacing={"1rem"} sx={{padding:{xs:"1.5rem",md:"3rem"},maxWidth:{xs:'auto',xl:"2000px"}}} alignItems={"center"}  >
        <Grid2 container size={{xs:12,md:6}}  justifyContent={{xs:"center",md:"flex-start"}}>
            <img src={formPage} style={{width:'85%',height:"100%"}}/>
        </Grid2>
        <Grid2 size={{xs:12,md:6}} sx={{pr:{xs:0,md:"3rem",fontFamily: 'Roboto, Arial, sans-serif',}}}>
          <Typography variant="h2" sx={{fontSize:{xs:"35px",md:"40px"},fontWeight:700,fontFamily:"inherit"}}>Benefits</Typography>
            {/* <Typography variant="h1" sx={{letterSpacing:0.3,lineHeight:1.5,fontWeight:300,fontFamily:"inherit",fontSize:"20px",mt:"1rem"}}>A <span style={{color:commonCss.orange,fontWeight:600}}>Safety Walk</span> is a digital platform designed to streamline safety inspections, audits, and reporting processes in workplaces. It typically helps organizations ensure compliance with safety standards, identify hazards, and promote a safer environment.</Typography>
            
            <Typography sx={{fontSize:"1.1rem",fontWeight:700,fontFamily:"inherit",mt:4}}>Benefits</Typography> */}
            <List sx={{'& .MuiListItemText-primary': {
              fontFamily: 'Roboto, sans-serif', 
              fontSize:"1.1rem",
              fontWeight:400
            },
            display:"flex",
            columnGap:"1rem",
            flexWrap:"wrap",
            width:'100%',
            mt:1,
            }} >
             
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText >Enhances workplace safety and compliance.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Streamlines data collection and reporting.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Reduces paperwork with digital records.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Improves team communication with task tracking and alerts.</ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Access to historical safety e-Forms
                  </ListItemText>
                </ListItem>
                <ListItem sx={{p:0,width:{xs:"100%"}}}>
                <ListItemIcon>
                    <ArrowForward />
                  </ListItemIcon>
                  <ListItemText>Interactive dashboards & KPIs</ListItemText>
                </ListItem>
            </List>
        </Grid2>
     </Grid2>
     </Grid2>
    </Grid2>
  );
};

export default SafetyWalk;
